import React, { useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'

import { useNavigate } from 'react-router-dom-v5-compat'
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { PencilAlt } from '@styled-icons/heroicons-outline/PencilAlt'

import { get } from 'lodash'
import { handleError } from 'utils/error'
import { getConfiguredServiceDetailsPageUrl } from 'router/routes'
import { useDeleteDraftConfiguredServiceMutation } from 'api/configured-service/draftPricingCSCrud'

import T from 'T'
import HHConfirmDialog from 'components/common/HHConfirmDialog'

const DraftServiceActionMenu = ({ anchorEl, selectedService, locationId = '', accountId = '', onEditService = noop, onClose = noop }) => {
  const navigate = useNavigate()
  const [deleteDraftCS, { isLoading }] = useDeleteDraftConfiguredServiceMutation()
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false)
  const id = get(selectedService, 'id')

  const handleGoToServicePage = () => {
    const baseUrl = getConfiguredServiceDetailsPageUrl(id)
    const params = new URLSearchParams({ locationId, accountId }).toString()
    navigate(`${baseUrl}?${params}`)
    onClose()
  }

  const handleEditDraftService = () => {
    onEditService()
    onClose()
  }

  const handleDeleteClick = () => {
    setIsConfirmDialogOpen(true)
    onClose()
  }

  const handleConfirmDelete = async () => {
    try {
      await deleteDraftCS({ id }).unwrap()
      setIsConfirmDialogOpen(false)
    } catch (error) {
      handleError('Error deleting draft service:', error)
    }
  }

  const handleCloseConfirmDialog = () => {
    setIsConfirmDialogOpen(false)
  }

  return (
    <>
      <Menu
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { variant: 'outlined' } }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        disableScrollLock
      >
        <MenuItem onClick={handleGoToServicePage}>
          <ListItemIcon sx={{ mr: 1 }}>
            <OpenInNewIcon />
          </ListItemIcon>
          <ListItemText>{T.GO_TO_SERVICE_PAGE}</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleEditDraftService}>
          <ListItemIcon sx={{ mr: 1 }}>
            <PencilAlt width={24} height={24} />
          </ListItemIcon>
          <ListItemText>{T.EDIT_SERVICE}</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleDeleteClick}>
          <ListItemIcon sx={{ mr: 1 }}>
            <DeleteOutlineIcon color="error" />
          </ListItemIcon>
          <ListItemText
            slotProps={{
              primary: {
                color: 'error',
              },
            }}
          >
            {T.DELETE_DRAFT_SERVICE}
          </ListItemText>
        </MenuItem>
      </Menu>
      <HHConfirmDialog
        onConfirm={handleConfirmDelete}
        onClose={handleCloseConfirmDialog}
        confirmTitle={T.CONFIRMATION}
        confirmDescription="Are you sure you want to delete this draft service?"
        confirmButtonTitle={T.DELETE_DRAFT_SERVICE}
        isOpen={isConfirmDialogOpen}
        ConfirmButtonProps={{
          loading: isLoading,
        }}
      />
    </>
  )
}

DraftServiceActionMenu.propTypes = {
  anchorEl: PropTypes.object,
  selectedService: PropTypes.object,
  locationId: PropTypes.string,
  accountId: PropTypes.string,
  onEditService: PropTypes.func,
  onClose: PropTypes.func.isRequired,
}

export default DraftServiceActionMenu
